import { render, staticRenderFns } from "./demoReport.vue?vue&type=template&id=58061eae&"
import script from "./demoReport.vue?vue&type=script&lang=js&"
export * from "./demoReport.vue?vue&type=script&lang=js&"
import style0 from "./demoReport.vue?vue&type=style&index=0&id=58061eae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports